import { MainContentWrapper, ViewWrapper } from "@/components/layout/ViewWrapper.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card.tsx";
import { Input } from "@/components/ui/input.tsx";
import { Label } from "@/components/ui/label.tsx";
import { useState } from "react";
import { Link } from "wouter";

/**
 * MessagingConsent displays a compliant messaging consent form for users to provide their contact details and consent.
 * Uses brand styles and components. Does not submit anywhere yet.
 */
export const MessagingConsent = () => {
  // const [offers, setOffers] = useState(false);
  // const [acceptTerms, setAcceptTerms] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <ViewWrapper headerContent={null}>
        <MainContentWrapper columns={7}>
          <div className="flex flex-col items-center justify-center min-h-[80vh] py-8">
            <Card className="w-full max-w-md shadow-lg animate-fade-in">
              <CardHeader className="items-center pb-0">
                <CardTitle className="text-center text-2xl font-bold text-primary mb-2">
                  Thank you for providing your contact details!
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col items-center gap-4 pt-2">
                <div className="text-lg text-muted-foreground text-center">
                  Can&apos;t wait to talk to you!
                  <br />
                  You can return to the home screen below.
                </div>
              </CardContent>
              <CardFooter className="flex flex-col items-center gap-2 pt-0">
                <Button
                  asChild
                  variant="primary"
                  className="w-full mt-2"
                  data-statsig-name="messaging-consent-return-home"
                >
                  <Link href="/">Return Home</Link>
                </Button>
              </CardFooter>
            </Card>
          </div>
        </MainContentWrapper>
      </ViewWrapper>
    );
  }

  return (
    <ViewWrapper headerContent={null}>
      <MainContentWrapper columns={7}>
        <div className="flex flex-col items-center justify-center min-h-[80vh] py-8">
          <Card className="w-full max-w-md shadow-lg">
            <CardHeader className="items-center">
              <CardTitle className="text-center text-2xl font-bold text-primary mb-2">
                Please provide your
                <br />
                contact details
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                <div>
                  <Label htmlFor="firstName">
                    First name<span className="text-destructive">*</span>
                  </Label>
                  <Input
                    id="firstName"
                    name="firstName"
                    placeholder="First Name Example"
                    required
                    autoComplete="given-name"
                  />
                </div>
                <div>
                  <Label htmlFor="lastName">Last name</Label>
                  <Input
                    id="lastName"
                    name="lastName"
                    placeholder="Last Name Example"
                    autoComplete="family-name"
                  />
                </div>
                <div>
                  <Label htmlFor="email">
                    Email<span className="text-destructive">*</span>
                  </Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="example@smsoptin.com"
                    required
                    autoComplete="email"
                  />
                </div>
                <div>
                  <Label htmlFor="phone">
                    Phone number<span className="text-destructive">*</span>
                  </Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    placeholder="1234567890"
                    autoComplete="tel"
                  />
                </div>
                {/* <div className="flex flex-col gap-2 mt-2">
                  <label className="flex items-center gap-2">
                    <Checkbox id="offers" checked={offers} onCheckedChange={(v) => setOffers(!!v)} />
                    <span className="text-sm">I would like to receive offers and news</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <Checkbox id="acceptTerms" checked={acceptTerms} onCheckedChange={(v) => setAcceptTerms(!!v)} />
                    <span className="text-sm">
                      I accept the{" "}
                      <a href="#" className="underline text-primary">Terms of Service &amp; Privacy Policy</a>
                    </span>
                  </label>
                </div> */}
                <div className="text-xs text-muted-foreground mt-4">
                  By providing your phone number you agree to receive informational text messages
                  from Okthx. Consent is not a condition of purchase. Messages Frequency will vary.
                  Msg &amp; data rates may apply. Reply HELP for help or STOP to cancel.
                </div>
                <div className="flex gap-2 mt-6">
                  <Button
                    type="button"
                    variant="outline"
                    className="flex-1"
                    disabled
                    data-statsig-name="messaging-consent-skip"
                  >
                    SKIP
                  </Button>
                  <Button
                    type="submit"
                    className="flex-1"
                    data-statsig-name="messaging-consent-continue"
                  >
                    CONTINUE
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </MainContentWrapper>
    </ViewWrapper>
  );
};
